import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'displayTimeOnYAxis',
  standalone: false,
})
export class DisplayTimeOnYAxisPipe implements PipeTransform {
  transform(timeIndex: number, timeLabelIndexesBetweenStartAndEnd: number[]): boolean {
    return timeLabelIndexesBetweenStartAndEnd.includes(timeIndex);
  }
}
